export default __webpack_public_path__ + "static/avatar-tag-2-dont-light-98010cab770304ad7e882f5d6f40fe63.png";